import { render, staticRenderFns } from "./customsCommodityCode.vue?vue&type=template&id=2c903cd3&scoped=true&"
import script from "./customsCommodityCode.vue?vue&type=script&lang=js&"
export * from "./customsCommodityCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c903cd3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c903cd3')) {
      api.createRecord('2c903cd3', component.options)
    } else {
      api.reload('2c903cd3', component.options)
    }
    module.hot.accept("./customsCommodityCode.vue?vue&type=template&id=2c903cd3&scoped=true&", function () {
      api.rerender('2c903cd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/customsCommodityCode.vue"
export default component.exports